import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { wipeLocal } from "@/lib/offlineStore";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const raw = localStorage.getItem("trulyn_user");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    });
    const [loading, setLoading] = useState(false);

    const login = useCallback(async (email, password) => {
        const res = await api.post("/auth/login", { email, password });
        const { access_token, user: u } = res.data;
        localStorage.setItem("trulyn_token", access_token);
        localStorage.setItem("trulyn_user", JSON.stringify(u));
        setUser(u);
        return u;
    }, []);

    const logout = useCallback(() => {
        localStorage.removeItem("trulyn_token");
        localStorage.removeItem("trulyn_user");
        setUser(null);
        // best-effort wipe of local offline cache
        wipeLocal().catch(() => {});
    }, []);

    const refresh = useCallback(async () => {
        try {
            setLoading(true);
            const res = await api.get("/auth/me");
            localStorage.setItem("trulyn_user", JSON.stringify(res.data));
            setUser(res.data);
        } catch {
            logout();
        } finally {
            setLoading(false);
        }
    }, [logout]);

    useEffect(() => {
        const token = localStorage.getItem("trulyn_token");
        if (token && !user) {
            refresh();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
